import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

const BASE = (import.meta.env.VITE_API_URL as string | undefined) ?? 'http://127.0.0.1:8787';

export interface ApiCategory {
  id: string;
  name: string;
  slug: string;
  description: string | null;
  imageUrl: string | null;
  sortOrder: number;
  isActive: boolean;
}

export const categoriesApi = createApi({
  reducerPath: 'categoriesApi',
  baseQuery: fetchBaseQuery({
    baseUrl: BASE,
    prepareHeaders: (headers) => {
      const token = localStorage.getItem('auth_token');
      if (token) headers.set('Authorization', `Bearer ${token}`);
      return headers;
    },
  }),
  tagTypes: ['Category'],
  endpoints: (build) => ({
    getCategories: build.query<ApiCategory[], void>({
      query: () => '/api/v1/categories',
      transformResponse: (r: { data: ApiCategory[] }) => r.data,
      providesTags: ['Category'],
      keepUnusedDataFor: 300,
    }),
    createCategory: build.mutation<ApiCategory, unknown>({
      query: (body) => ({ url: '/api/v1/categories', method: 'POST', body }),
      invalidatesTags: ['Category'],
    }),
    updateCategory: build.mutation<ApiCategory, { id: string; body: unknown }>({
      query: ({ id, body }) => ({ url: `/api/v1/categories/${id}`, method: 'PUT', body }),
      invalidatesTags: ['Category'],
    }),
    deleteCategory: build.mutation<void, string>({
      query: (id) => ({ url: `/api/v1/categories/${id}`, method: 'DELETE' }),
      invalidatesTags: ['Category'],
    }),
  }),
});

export const {
  useGetCategoriesQuery,
  useCreateCategoryMutation,
  useUpdateCategoryMutation,
  useDeleteCategoryMutation,
} = categoriesApi;
